import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from './ActionButton';
import permissionsProvider from '../../../utilities/permissionsProvider';

const SaveCancelButton = ({
    cancelEdit,
    acl,
    saveItem,
    showText,
    saveText,
    cancelText
}) => (

    <div>
        <div className="button-wrapper d-inline-block">
            <ActionButton
                buttonText={showText === true ? saveText || 'Save' : ''}
                imgSource="/images/check.svg"
                onClick={saveItem}
                disabled={!permissionsProvider.canEdit(acl)}
            />
        </div>
        <div className="button-wrapper d-inline-block">
            <ActionButton
                buttonText={showText === true ? cancelText || 'Cancel' : ''}
                imgSource="/images/cancel.svg"
                onClick={cancelEdit}
            />
        </div>
    </div>
);

SaveCancelButton.propTypes = {
    cancelEdit: PropTypes.func,
    canSave: PropTypes.bool,
    saveItem: PropTypes.func
};

SaveCancelButton.defaultProps = {
    canSave: true,
    showText: true
}

export default SaveCancelButton;